import HasLabel from 'hocs/HasLabel';
import HasIcon from 'hocs/HasIcon';
import HasError from 'hocs/HasError';
import HasPasswordToggle from 'hocs/HasPasswordToggle';
import Input from './Input';

export const InputHasError = HasError(Input);
export const InputHasIcon = HasIcon(Input);

export const InputHasErrorIcon = HasError(InputHasIcon);
export const InputHasLabelError = HasLabel(InputHasError);

export const InputHasPasswordToggleErrorIcon = HasPasswordToggle(
  InputHasErrorIcon
);

export const InputHasPasswordToggleError = HasPasswordToggle(InputHasError);

export const InputHasPasswordToggleLabelError = HasPasswordToggle(
  InputHasLabelError
);
